<template>
  <div class="select-row" style="display: flex; gap: 8px; margin-bottom: 8px">
    <Select
      v-model="localValue1"
      style="width: 120px"
      @on-change="handleChange"
      :clearable="false"
      :disabled="disabled"
      placeholder="请选择类型"
    >
      <Option v-for="item in conditionTypeList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Select
      v-show="localValue1 == 'android'"
      v-model="localValue2"
      style="width: 120px"
      @on-change="handleChange"
      :clearable="false"
      :disabled="disabled"
      placeholder="请选择条件"
    >
      <Option v-for="item in conditionList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Select
      v-show="localValue1 == 'android'"
      v-model="localValue3"
      style="width: 120px"
      @on-change="handleChange"
      :clearable="false"
      :disabled="disabled"
      placeholder="请选择版本号"
    >
      <Option v-for="item in androidVerList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Select
      v-show="localValue1 == 'channel'"
      v-model="localValue4"
      style="width: 245px"
      @on-change="handleChange"
      :clearable="false"
      multiple filterable
      :disabled="disabled"
      placeholder="请选择渠道"
    >
      <Option v-for="item in channelList" :value="item.value" :key="item.value">{{
        item.label
      }}</Option>
    </Select>
    <Button :disabled="disabled" type="error" icon="ios-trash" @click="handleDelete" />
  </div>
</template>
<script>
export default {
  name: 'SelectRow',
  props: {
    type: {
      type: String,
      default: ''
    },
    condition: {
      type: String,
      default: ''
    },
    version: {
      type: String,
      default: ''
    },
    channel: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      required: true
    },
    conditionTypeList: {
      type: Array,
      default: () => []
    },
    conditionList: {
      type: Array,
      default: () => []
    },
    androidVerList: {
      type: Array,
      default: () => []
    },
    channelList: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue1: this.type,
      localValue2: this.condition,
      localValue3: this.version,
      localValue4: this.channel
    }
  },
  methods: {
    handleDelete () {
      this.$emit('delete', this.index)
    },
    handleChange () {
      this.$emit('change', {
        index: this.index,
        type: this.localValue1,
        condition: this.localValue2,
        version: this.localValue3,
        channel: this.localValue4
      })
    }
  },
  watch: {
    type (val) {
      this.localValue1 = val
    },
    condition (val) {
      this.localValue2 = val
    },
    version (val) {
      this.localValue3 = val
    },
    channel (val) {
      console.log(val)
      this.localValue4 = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/esApp/selectRowTwo.vue